import { ViewLarge, Viewport, ViewSmall } from "@shared-ui/viewport-context";
import * as React from "react";
import { UitkButtonSize, UitkSecondaryButton } from "uitk-react-button";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkIcon } from "uitk-react-icons";

import { ExtendedContextStore } from "src/typings/flexFramework/FlexDefinitions";
import { HotwireAppLinkType, useHotwireAppSearchUrl } from "src/components/utility/hotwire/HotwireAppLinkUtil";

interface HotwireDealViewProp {
  label: string;
  buttonLink: string;
  modelKey: string;
  context: ExtendedContextStore;
}

interface CommonButtonProps {
  size: UitkButtonSize;
  href: string;
  "data-testid": string;
}

const dataTestIds = {
  today: "tonight",
  thisWeekend: "this-weekend",
  nextWeekend: "next-weekend",
};

export const HotwireDealView: React.FC<HotwireDealViewProp> = ({ label, buttonLink, modelKey, context }) => {
  const href = useHotwireAppSearchUrl(HotwireAppLinkType.HOTEL, buttonLink, context);

  const commonProps: CommonButtonProps = {
    size: UitkButtonSize.LARGE,
    href,
    "data-testid": dataTestIds[modelKey],
  };

  return (
    <Viewport>
      <ViewSmall>
        <UitkSpacing padding={{ inline: "unset" }} margin={{ blockstart: "one", blockend: "three" }}>
          <UitkSecondaryButton {...commonProps} tag="a" isFullWidth>
            <UitkIcon name="today" />
            {label}
          </UitkSecondaryButton>
        </UitkSpacing>
      </ViewSmall>
      <ViewLarge>
        <UitkSpacing margin={{ blockstart: "one", inlineend: "three" }}>
          <UitkSecondaryButton {...commonProps} tag="a">
            <UitkIcon name="today" />
            {label}
          </UitkSecondaryButton>
        </UitkSpacing>
      </ViewLarge>
    </Viewport>
  );
};
